import { useMutation } from "react-query";
import { getFreshAccessToken } from "../use-user";

const CREATE_SHIPPING_METADATA = `
  mutation CreateShippingMetadata($input: ShippingMetadataInput!) {
  createShippingMetadata(input: $input) {
    success
  }
}
`;

export const useCreateShippingMetadata = () => {
  return useMutation({
    mutationFn: async ({ shippingId, key, value }) => {
      const accessToken = getFreshAccessToken();
      const res = await fetch(process.env.REACT_APP_TES_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-client-id": process.env.REACT_APP_CLIENT_ID || "lego-test",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query: CREATE_SHIPPING_METADATA,
          variables: { input: { shipping_id: shippingId, key, value } },
        }),
      });

      return res.json();
    },
  });
};
